import { combineReducers } from "redux";
import { themeReducer } from "./theme/theme.reducer";
import userSlice from "./user/user.slice";
import siteDataSlice from "./data/data.slice";
import serviceSlice from "./service/service.slice";

export const rootReducer = combineReducers({
  theme: themeReducer,
  user: userSlice.reducer,
  data: siteDataSlice.reducer,
  services: serviceSlice.reducer,
});
